import { RootStore } from "./root";

let clientStore: RootStore | null = null;

const initStore = (): RootStore => {
  const store = clientStore ?? new RootStore();
  if (!clientStore) {
    clientStore = store;
  }

  return store;
};

export const getStore = (): RootStore => clientStore!;

export const useStore = (): RootStore => initStore();

export * from "./root";
